document.querySelectorAll('.footer-toggle').forEach((toggle) => {
  toggle.addEventListener('click', () => {
    const targetId = toggle.dataset.target;
    const targetMenu = document.getElementById(targetId);

    if (targetMenu.classList.contains('open')) {
      targetMenu.classList.remove('open');
    } else {
      document.querySelectorAll('.footer-submenu').forEach((menu) => menu.classList.remove('open'));
      targetMenu.classList.add('open');
    }
  });
});
